import { Text } from "@primer/react";
import { AlertFillIcon, CheckCircleFillIcon } from "@primer/octicons-react";
import { profileShareSummary } from "../../domain/profileShare.js";
import "./SharedProfile.css";

export function SharedProfileStatus({ status }) {
  if (!status) return null;
  const Icon = status.tone === "danger" ? AlertFillIcon : CheckCircleFillIcon;
  return <Text className={`share-feedback ${status.tone}`} role={status.tone === "danger" ? "alert" : "status"}><Icon aria-hidden="true" />{status.text}</Text>;
}

export function SharedProfileSummary({ share }) {
  const summary = profileShareSummary(share);
  return <dl className="shared-profile-summary"><div><dt>Assets</dt><dd>{summary.assets}</dd></div><div><dt>Properties</dt><dd>{summary.properties}</dd></div><div><dt>Policies</dt><dd>{summary.policies}</dd></div><div><dt>Views</dt><dd>{summary.browserViews}</dd></div></dl>;
}
